export default {
  all: "all",
  booked: "booked",
  available: "available",
};
